import { SupportTeamStateEvent, GetAllSupportTeamSuccessEvent } from './state-event'
import { SupportTeam } from '../incident/model'

export const supportTeamStateReducer = (state: SupportTeam[] = [], event: SupportTeamStateEvent<any> = { type: undefined, payload: undefined}) => {
    if (event.type === GetAllSupportTeamSuccessEvent.type) {
        return event.payload || []
    } else {
        return state
    }
}
